import { tbGraphics } from "./tbGraphics";
import { tbLoader } from "./tbLoader";
var tbVectorFontLoader = /** @class */ (function () {
    function tbVectorFontLoader(fontFace, woffPath, ttfPath, loadMoment) {
        this.fontFace = fontFace;
        this.woffPath = woffPath;
        this.ttfPath = ttfPath;
        // Measurement to check whether the font has been loaded
        this._fallbackMeasurements = [
            { text: "MiHhX!@v&Qq", width: -1, font: "sans-serif" },
            { text: "MiHhX!@v&Qq", width: -1, font: "serif" },
            { text: "AaMm#@!Xx67", width: -1, font: "sans-serif" },
            { text: "AaMm#@!Xx67", width: -1, font: "serif" }
        ];
        this.success = false;
        // Add it to the loader
        tbLoader.addResource(this, loadMoment, 1);
    }
    // Compute the width of a text
    tbVectorFontLoader.prototype._computeWidth = function (font, fallback, text) {
        if (!tbGraphics.fontContext) {
            return;
        }
        var width;
        tbGraphics.fontContext.save();
        tbGraphics.fontContext.font = "250pt " + font + ", " + fallback;
        width = tbGraphics.fontContext.measureText(text).width;
        tbGraphics.fontContext.restore();
        return width;
    };
    // Add the fontface to the style
    tbVectorFontLoader.prototype._addToCss = function (location) {
        // Define css
        var cssCode = "@font-face {" +
            "font-family: " + this.fontFace + ";" +
            "src: url('" + location + this.woffPath + "') format('woff'), " +
            "url('" + location + this.ttfPath + "') format('truetype');" +
            "}", 
        // Create CSS element
        styleElement = document.createElement("style");
        styleElement.id = this.fontFace + "_fontface";
        styleElement.type = "text/css";
        if (styleElement["styleSheet"]) {
            styleElement["styleSheet"].cssText = cssCode;
        }
        else {
            styleElement.appendChild(document.createTextNode(cssCode));
        }
        // Add CSS element to head
        document.getElementsByTagName("head")[0].appendChild(styleElement);
    };
    // Add an element to the DOM to force loading the font
    tbVectorFontLoader.prototype._addToDom = function () {
        var i, measurement;
        // Create the DOM element to start the loading
        this.DOMElement = document.createElement("span");
        this.DOMElement.style.position = "absolute";
        this.DOMElement.style.left = "-9999px";
        this.DOMElement.style.top = "-9999px";
        this.DOMElement.style.visibility = "hidden";
        this.DOMElement.style.fontSize = "250pt";
        this.DOMElement.id = this.fontFace + "_loader";
        // Add the element to the DOM
        document.body.appendChild(this.DOMElement);
        // Do initial _fallbackMeasurements
        for (i = 0; i < this._fallbackMeasurements.length; i += 1) {
            measurement = this._fallbackMeasurements[i];
            measurement.width = this._computeWidth(measurement.font, measurement.font, measurement.text);
        }
    };
    // This loop checks whether the font is loaded
    tbVectorFontLoader.prototype._cycle = function () {
        var _this = this;
        var measurement, width;
        // Do the check
        for (var i = 0; i < this._fallbackMeasurements.length; i += 1) {
            measurement = this._fallbackMeasurements[i];
            width = this._computeWidth(this.fontFace, measurement.font, measurement.text);
            // Check whether width is changed (then the font is loaded)
            if (measurement.width !== width) {
                tbLoader.loadComplete(this.loadMoment);
                document.body.removeChild(this.DOMElement);
                this.success = true;
                return;
            }
        }
        // If not loaded, loop
        window.setTimeout(function () { _this._cycle(); }, 33);
    };
    tbVectorFontLoader.prototype.startLoading = function (moment, location) {
        var _this = this;
        if (tbLoader.complete(moment)) {
            return Promise.resolve();
        }
        if (this._loadPromise) {
            return this._loadPromise;
        }
        this._loadPromise = new Promise(function (resolve) {
            var waiter = function () {
                if (!_this.success) {
                    setTimeout(waiter, 100);
                }
                else {
                    resolve();
                }
            };
            _this._addToCss(location);
            _this._addToDom();
            _this.loadMoment = moment;
            _this._cycle();
            waiter();
        });
        return this._loadPromise;
    };
    // Returns whether loading is complete (true)
    tbVectorFontLoader.prototype.complete = function () {
        return this.success;
    };
    return tbVectorFontLoader;
}());
export { tbVectorFontLoader };
